import Profile from "./module/userProfile";

const profile = new Profile();

function blendToggle(current, change, duration) {
  if (current.is(":visible")) {
    current.fadeToggle(duration, "swing", function () {
      change.fadeToggle();
    });
  } else {
    change.fadeToggle(duration, "swing", function () {
      current.fadeToggle();
    });
  }
}

jQuery(document).ready(function ($) {
  $(".page-login__resend-password button, .page-login__login button").on(
    "click",
    (e) => {
      let login_text = $(".page-login__login");
      let login_form = $(".page-login__form__login");
      let create_text = $(".page-login__resend-password");
      let create_form = $(".page-login__form__resend-password");

      blendToggle(login_text, create_text, 400);
      blendToggle(login_form, create_form, 400);

      $(".page-login__form__wrapper").toggleClass("reorder");
      $(".page-login__content__wrapper").toggleClass(
        "reorder offset-lg-6 offset-lg-7 offset-xxl-7 offset-xxl-8 ps-lg-7half"
      );
    }
  );
});

const alpineData = () => {
  return {
    email: "",
    emailResendMail: "",
    displayForm: true,
    displayFormResendMail: true,
    requestPasswordToken: async function () {
      const request = profile.requestPasswordResetToken(this.email);
      const response = await request;

      if (response) {
        this.displayForm = false;
      }
    },
    resendConfirmMail: async function () {
      const request = profile.resendConfirmMail(this.emailResendMail);
      const response = await request;

      if (response) {
        this.displayFormResendMail = false;
      }
    },
  };
};

if(!window.alpineData) {
  window.alpineData = {};
}
window.alpineData.appForgotPassword = alpineData;
